<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <BookTabs
        :book="book"
        v-model="currentTab"
        @delete="deleteBook"
        @edit="editBook"
      />
      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="book">
          <BookDetails :book="book"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { booksService } from '../../utils/services/books.service';
  import BookTabs from '../../components/app/Books/BookTabs';
  import BookDetails from '../../components/app/Books/BookDetails';
  import BookModal from '../../components/modals/Books/BookModal';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'BookShow',
    components: {
        Loader,
        BookTabs,
        BookDetails,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        book: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchBook(id) {
        return booksService.get(id)
        .then(response => {
          this.book = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deleteBook() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return booksService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(this.routeName.BOOK);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editBook() {
          this.showModal({
              component: BookModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('BOOKS'),
                onSave: (
                  form,
                  error,
                ) => booksService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchBook(this.id);
      this.loading = false;
    },
  };
</script>
